import { render, staticRenderFns } from "./_biomarker.vue?vue&type=template&id=738f756e&"
import script from "./_biomarker.vue?vue&type=script&lang=js&"
export * from "./_biomarker.vue?vue&type=script&lang=js&"
import style0 from "./_biomarker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TestHeader: require('/home/runner/work/webpage/webpage/components/test/header/header.vue').default,TestStarterTest: require('/home/runner/work/webpage/webpage/components/test/starter-test/starter-test.vue').default,QuizResultsHowItWorks: require('/home/runner/work/webpage/webpage/components/quiz-results/how-it-works/how-it-works.vue').default,AreaKeyPoints: require('/home/runner/work/webpage/webpage/components/area/key-points/key-points.vue').default,AreaAppB: require('/home/runner/work/webpage/webpage/components/area/app-b/app-b.vue').default,HomeSampleReport: require('/home/runner/work/webpage/webpage/components/home/sample-report/sample-report.vue').default,TestTestimonialsImage: require('/home/runner/work/webpage/webpage/components/test/testimonials-image/testimonials-image.vue').default,AreaFaqs: require('/home/runner/work/webpage/webpage/components/area/faqs/faqs.vue').default,BaseFloatingButton: require('/home/runner/work/webpage/webpage/components/base/floating-button/floating-button.vue').default})
